<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Facilities</h1>
                    <div class="custom_toolbar">
                        <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search">
                        <el-button style="margin-left: 20px;" type="success" round icon="el-icon-plus" @click="createNew">Create New</el-button>
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <vue-good-table v-loading="loading"
                        mode="remote"
                        :columns="columns"
                        :rows="rows"
                        :totalRows="totalRecords"
                        @on-page-change="onPageChange"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">

                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'name'">
                                <el-row type="flex" justify="center">
                                    <el-col :span="4">
                                        <el-upload
                                            class="avatar-uploader"
                                            :action="`https://api.bniservicerating.com/v1/facilities/image/${props.row.id}`"
                                            :headers="headers"
                                            name="image"
                                            :show-file-list="false"
                                            :on-success="fetch">
                                            <!-- <img v-if="props.row.image" :src="props.row.image" class="avatar"> -->
                                            <el-image v-if="props.row.image"
                                                style="width: 40px; height: 40px; border-radius: 4px;"
                                                fit="cover"
                                                :src="props.row.image">
                                            </el-image>

                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-col>
                                    <el-col :span="20">
                                        {{props.row.name}}<br/>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else-if="props.column.field == 'suggestions'">
                                <span v-if="props.row.suggestions">
                                    <el-tag style="margin-right:4px; margin-bottom: 4px;" size="small" type="info" v-for="(item,index) in JSON.parse(props.row.suggestions)" :key="index">{{item}}</el-tag>
                                </span>
                            </span>
                            <span v-else-if="props.column.field == 'min_star'">
                                <el-rate
                                    :value="props.row.min_star"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    score-template="{value} star">
                                </el-rate>
                            </span>
                            <span v-else-if="props.column.field == 'action'">
                                <el-button size="mini" icon="el-icon-edit" circle @click="editFacility(props.row.originalIndex)"></el-button>
                                <el-button size="mini" type="danger" icon="el-icon-delete" @click="showAlertDelete(props.row.id)" circle></el-button>
                            </span>
                            <span v-else-if="props.column.field == 'status'">
                                <el-switch active-color="#13ce66" inactive-color="#edf1f7" :value="props.row.status==1 ? true : false" @change="switchChanged(props.row.originalIndex)"></el-switch>
                            </span>
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>

                    </vue-good-table>
                </div>
            </div>
        </div>

        <el-dialog title="Edit Facility" :visible.sync="dialogFormVisible" width="40%">
            <el-form :model="form">
                <el-form-item label="Name">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Minimum Rate">
                    <div style="margin: 40px 0 0;"></div>
                    <el-rate show-score text-color="#ff9900" score-template="{value} star" v-model="form.min_star"></el-rate>
                </el-form-item>
                <el-form-item label="Details">
                    <!-- <el-input v-model="form.suggestions" autocomplete="off"></el-input> -->
                    <div style="margin: 40px 0 0;"></div>
                    <el-tag style="margin-right: 4px;"
                        :key="tag"
                        v-for="tag in form.suggestions"
                        closable
                        type="info"
                        :disable-transitions="false"
                        @close="handleCloseTag(tag)">
                        {{tag}}
                    </el-tag>
                    <el-input style="width: 90px;"
                        class="input-new-tag"
                        v-if="inputTagVisible"
                        v-model="inputTagValue"
                        ref="saveTagInput"
                        size="mini"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Add New</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="saveFacility()" :loading="loading2">Confirm</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import apiKey from '@/api/api'
    import api from '@/api/facilities'
    import regions from '@/api/regions'
    import { mapActions } from 'vuex';

    export default {
        name: 'facilities',
        components: {
            'vue-good-table':VueGoodTable
        },
        data() {
            return {
                headers: {'x-api-key': 'ZE92pkHlV2gDoj5eddjAO21Zkz5Qxpnq', 'x-access-token': localStorage.getItem('accessToken')},
                inputTagVisible: false,
                inputTagValue: '',
                dialogFormVisible: false,
                formType: 'edit',
                form: {
                    id: '',
                    name: '',
                    min_star: '',
                    suggestions: ''
                },
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        width: '30%'
                    },
                    {
                        label: 'Minimum Star',
                        field: 'min_star',
                        width: '200px'
                    },
                    {
                        label: 'Details',
                        field: 'suggestions'
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center'
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        thClass: 'u-text-center',
                        tdClass: 'u-text-center',
                        width: '100px'
                    }
                ],
                rows: [],
                totalRecords: 0,
                page: 1,
                params: {
                    q: ''
                },
                loading: false,
                loading2: false
            }
        },
        created () {
            this.fetch();
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            image(id) {
                this.loading = true
                var self = this
                api.image(id)
                .then(function (response) {
                    self.fetch()
                    self.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetch() {
                this.loading = true
                var self = this
                api.get(this.page, this.params.q)
                .then(function (response) {
                    self.rows = response.data.data
                    self.totalRecords = response.data.meta.totalRecords
                    self.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            onPageChange(params) {
                console.log(params)
                this.page = params.currentPage
                this.fetch();
            },
            myChangeEvent4(val){
                console.log(val);
                this.params.position = val
                this.fetch();
            },
            search() {
                this.fetch();
            },
            switchChanged(id){
                console.log(id);
                console.log(this.rows[id])
                var self = this
                api.update(this.rows[id].id, {status: !this.rows[id].status})
                .then(function (response) {
                    self.fetch()
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading2 = false
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            editFacility(id){
                this.formType = 'edit'
                // console.log(id)
                this.form = {
                    id: this.rows[id].id,
                    name: this.rows[id].name,
                    min_star: this.rows[id].min_star,
                    suggestions: this.rows[id].suggestions ? JSON.parse(this.rows[id].suggestions) : [],
                }
                this.dialogFormVisible = true
            },
            handleCloseTag(tag) {
                this.form.suggestions.splice( this.form.suggestions.indexOf(tag) , 1)
            },
            showInput() {
                this.inputTagVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputTagValue = this.inputTagValue;
                if (inputTagValue) {
                    this.form.suggestions.push(inputTagValue);
                }
                this.inputTagVisible = false;
                this.inputTagValue = '';
            },
            saveFacility(){
                if(this.formType == 'add'){
                    this.addFacility()
                } else {
                    var params = {
                        name: this.form.name,
                        min_star: this.form.min_star,
                        suggestions: JSON.stringify(this.form.suggestions),
                        status: 1
                    }
                    this.loading2 = true
                    var self = this
                    api.update(this.form.id, params)
                    .then(function (response) {
                        self.loading2 = false
                        self.dialogFormVisible = false
                        self.fetch()
                        self.$message({
                            type: 'success',
                            message: response.data.message
                        });
                    })
                    .catch(function (error) {
                        self.loading2 = false
                        console.log(error);
                        self.$message({
                            type: 'danger',
                            message: error.response.data.message
                        });
                        if(error.response.status == 403){
                            self.logout()
                        }
                    })
                }
            },
            showAlertDelete(id){
                this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.deleteFacility(id)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            deleteFacility(id){
                var self = this
                api.delete(id)
                .then(function (response) {
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            createNew() {
                this.formType = 'add'
                this.form = {
                    id: '',
                    name: '',
                    min_star: 0,
                    suggestions: [],
                }
                this.dialogFormVisible = true
            },
            addFacility() {
                var params = {
                    name: this.form.name,
                    min_star: this.form.min_star,
                    suggestions: JSON.stringify(this.form.suggestions),
                    status: 1
                }
                this.loading2 = true
                var self = this
                api.create(params)
                .then(function (response) {
                    self.loading2 = false
                    self.dialogFormVisible = false
                    self.fetch()
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading2 = false
                    console.log(error);
                    self.$message({
                        type: 'danger',
                        message: error.response.data.message
                    });
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div {
        margin-right: 10px;
    }
}
.el-row--flex.is-justify-center {
    align-items: center !important;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .avatar {
    width: 40px;
    height: 40px;
    display: block;
  }
</style>